export interface GetGTipListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetGTipListPagingAndFilterResponseData
}

export interface GetGTipListPagingAndFilterResponseData {
    items: GetGTipListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetGTipListPagingAndFilterResponseItem {
    gTipId: string
    gTip1: string
    gTipDesc: string
    gTip2: string
    gTip2Desc: string
    gTip4: string
    gTip4Desc: string
    gTip6: string
    gTip6Desc: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetGTipListPagingAndFilterResponseData: GetGTipListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}